






import Vue from 'vue';
import {Prop, Watch} from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
  name: 'InfoBox',
})
export default class AmetrasInfoBoxTemplate extends Vue {

  @Prop() label!: string;
  @Prop({
    type: String as () => DisguiseDto.EnumAlertType,
  }) alertType!: string;
  alertTypeValue!: string;

  @Watch('alertType') valueChanged(newValue: string) {
    this.alertTypeValue = newValue.toLowerCase();
  }

  created() {
    this.alertTypeValue = this.alertType.toLowerCase();
  }

}

